import { render } from "./SupplierTradingAgreements.vue?vue&type=template&id=f39aa9ba&scoped=true"
import script from "./SupplierTradingAgreements.vue?vue&type=script&lang=js"
export * from "./SupplierTradingAgreements.vue?vue&type=script&lang=js"

import "./SupplierTradingAgreements.vue?vue&type=style&index=0&id=f39aa9ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39aa9ba"]])

export default __exports__